import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import css from "./TerAct.module.css";
import { ClinicContext } from "../../Context/ClinicContext";
import { Head } from "../../Utils/Head";
import { UserContext } from "../../Context/UserContext";
import { updateUserFirebase } from "../../Utils/firebaseUser";

export const TemperamentAndCharacter = () => {
  const { userData, setUserData } = useContext(UserContext);
  const {
    step,
    setStep,
    answer1,
    setAnswer1,
    answer2,
    setAnswer2,
    answer3,
    setAnswer3,
    answer4,
    setAnswer4,
    answer5,
    setAnswer5,
    answer6,
    setAnswer6,
  } = useContext(ClinicContext);
  const navigate = useNavigate();
  const stepLength = 7;

  useEffect(() => {
    setAnswer1("");
    setAnswer2("");
    setAnswer3("");
    setAnswer4("");
    setAnswer5("");
    setAnswer6("");
  }, []);

  const checkCorrects = () => {
    let counter = 0;
    answer1 === "high" &&
      Math.round((userData.personalityTraits[0] * 100) / 35) >= 55 &&
      counter++;
    answer1 === "medium" &&
      Math.round((userData.personalityTraits[0] * 100) / 35) > 55 &&
      Math.round((userData.personalityTraits[0] * 100) / 35) < 45 &&
      counter++;
    answer1 === "low" &&
      Math.round((userData.personalityTraits[0] * 100) / 35) <= 45 &&
      counter++;
    answer2 === "high" &&
      Math.round((userData.personalityTraits[1] * 100) / 35) >= 55 &&
      counter++;
    answer2 === "medium" &&
      Math.round((userData.personalityTraits[1] * 100) / 35) > 55 &&
      Math.round((userData.personalityTraits[1] * 100) / 35) < 45 &&
      counter++;
    answer2 === "low" &&
      Math.round((userData.personalityTraits[1] * 100) / 35) <= 45 &&
      counter++;
    answer3 === "high" &&
      Math.round((userData.personalityTraits[2] * 100) / 35) >= 55 &&
      counter++;
    answer3 === "medium" &&
      Math.round((userData.personalityTraits[2] * 100) / 35) > 55 &&
      Math.round((userData.personalityTraits[2] * 100) / 35) < 45 &&
      counter++;
    answer3 === "low" &&
      Math.round((userData.personalityTraits[2] * 100) / 35) <= 45 &&
      counter++;
    answer4 === "high" &&
      Math.round((userData.personalityTraits[3] * 100) / 40) >= 55 &&
      counter++;
    answer4 === "medium" &&
      Math.round((userData.personalityTraits[3] * 100) / 40) > 55 &&
      Math.round((userData.personalityTraits[3] * 100) / 40) < 45 &&
      counter++;
    answer4 === "low" &&
      Math.round((userData.personalityTraits[3] * 100) / 40) <= 45 &&
      counter++;
    answer5 === "high" &&
      Math.round((userData.personalityTraits[4] * 100) / 50) >= 55 &&
      counter++;
    answer5 === "medium" &&
      Math.round((userData.personalityTraits[4] * 100) / 50) > 55 &&
      Math.round((userData.personalityTraits[4] * 100) / 50) < 45 &&
      counter++;
    answer5 === "low" &&
      Math.round((userData.personalityTraits[4] * 100) / 50) <= 45 &&
      counter++;
    answer6 === "high" &&
      Math.round((userData.personalityTraits[5] * 100) / 50) >= 55 &&
      counter++;
    answer6 === "medium" &&
      Math.round((userData.personalityTraits[5] * 100) / 50) > 55 &&
      Math.round((userData.personalityTraits[5] * 100) / 50) < 45 &&
      counter++;
    answer6 === "low" &&
      Math.round((userData.personalityTraits[5] * 100) / 50) <= 45 &&
      counter++;

    return counter;
  };

  const finish = () => {
    const updatedJourney = {
      level: 0,
      lesson: 3,
    };

    userData.journey = updatedJourney;
    setUserData(userData);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/");
  };

  return (
    <div className={css.container}>
      <Head
        title="TemperamentAndCharacter"
        description={"TemperamentAndCharacter - Mairini"}
      />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            navigate("/");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((stepLength - step) * 100) / stepLength}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <div className={css.gridMainContainer}>
            <h1>
              Você já se perguntou por que algumas coisas parecem naturais para
              você — como reagir com intensidade ou evitar conflitos — enquanto
              outras exigem mais esforço?
            </h1>
          </div>
        )}
        {step === 1 && (
          <div className={css.gridMainContainer}>
            <h1>
              A psicologia costuma separar dois grandes aspectos da nossa forma
              de ser:
            </h1>
            <h1>🧬 Temperamento</h1>
            <p>
              É mais biológico. Reflete seu estilo emocional básico — como você
              reage espontaneamente às situações.
            </p>
            <h1>🧠 Caráter</h1>
            <p>
              É mais aprendido. Representa seus valores, crenças e escolhas
              construídas ao longo da vida.
            </p>
          </div>
        )}
        {step === 2 && (
          <div className={css.gridMainContainer}>
            <h1>💡 Exemplo:</h1>
            <p>
              Uma pessoa pode ter um
              <span> temperamento mais impulsivo</span>, mas ter desenvolvido um
              <span> caráter flexível</span>, aprendendo a lidar com suas
              reações para cuidar melhor das relações.
            </p>
          </div>
        )}
        {step === 3 && (
          <div className={css.gridMainContainer}>
            <h1>Nenhum temperamento é “errado”.</h1>
            <p>
              Ele apenas aponta os caminhos onde você pode precisar de mais (ou
              menos) energia para agir com intenção.
            </p>
            <p>
              Refletir sobre seu próprio temperamento pode ajudar a entender:
            </p>
            <ul>
              <li>- Por que certas situações esgotam você</li>
              <li>- Onde há tendência à evitação ou controle</li>
              <li>- Como construir caminhos mais alinhados com seus valores</li>
            </ul>
          </div>
        )}
        {step === 4 && (
          <>
            <p>
              Agora que você entendeu mais sobre sua personalidade, vamos fazer
              um exercício usando os dados do questionário da última lição.
            </p>
            <h1>
              Como você distribuiria suas características dentre as seguintes
              dimensões?
            </h1>
            <table>
              <tbody>
                <tr>
                  <th>Emoção</th>
                  <th>
                    <button
                      className={
                        answer1 === "high"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer1("high")}
                    >
                      Alta
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer1 === "medium"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer1("medium")}
                    >
                      Média
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer1 === "low"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer1("low")}
                    >
                      Baixa
                    </button>
                  </th>
                </tr>
                <tr>
                  <th>Energia</th>
                  <th>
                    <button
                      className={
                        answer2 === "high"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer2("high")}
                    >
                      Alta
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer2 === "medium"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer2("medium")}
                    >
                      Média
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer2 === "low"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer2("low")}
                    >
                      Baixa
                    </button>
                  </th>
                </tr>
                <tr>
                  <th>Sociabilidade</th>
                  <th>
                    <button
                      className={
                        answer3 === "high"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer3("high")}
                    >
                      Alta
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer3 === "medium"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer3("medium")}
                    >
                      Média
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer3 === "low"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer3("low")}
                    >
                      Baixa
                    </button>
                  </th>
                </tr>
                <tr>
                  <th>Seguimento de Regras (Organização)</th>
                  <th>
                    <button
                      className={
                        answer4 === "high"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer4("high")}
                    >
                      Alta
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer4 === "medium"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer4("medium")}
                    >
                      Média
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer4 === "low"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer4("low")}
                    >
                      Baixa
                    </button>
                  </th>
                </tr>
                <tr>
                  <th>Imaginação (Abstração)</th>
                  <th>
                    <button
                      className={
                        answer5 === "high"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer5("high")}
                    >
                      Alta
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer5 === "medium"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer5("medium")}
                    >
                      Média
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer5 === "low"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer5("low")}
                    >
                      Baixa
                    </button>
                  </th>
                </tr>
                <tr>
                  <th>Assertividade (Manejo das Emoções)</th>
                  <th>
                    <button
                      className={
                        answer6 === "high"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer6("high")}
                    >
                      Alta
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer6 === "medium"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer6("medium")}
                    >
                      Média
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        answer6 === "low"
                          ? "defaultActiveButton"
                          : "defaultButton"
                      }
                      onClick={() => setAnswer6("low")}
                    >
                      Baixa
                    </button>
                  </th>
                </tr>
              </tbody>
            </table>
          </>
        )}
        {step === 5 && (
          <>
            <p>
              Você marcou {checkCorrects()} conforme o resultado do
              questionário.
            </p>
            <p>
              <span>
                A ideia aqui não é rotular, mas ampliar sua autocompreensão.{" "}
              </span>
              Saber como você funciona te ajuda a melhorar seu comportamento —
              especialmente nos momentos difíceis.
            </p>
            <table>
              <thead>
                <tr>
                  <th scope="col">Dimensão</th>
                  <th scope="col">Escolha</th>
                  <th scope="col">Questionário</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Emoção</th>
                  <td>
                    <p>
                      {answer1 === "high"
                        ? "Alta"
                        : answer1 === "low"
                        ? "Baixa"
                        : "Média"}
                    </p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[0] * 100) / 35) >=
                      55
                        ? "Alta"
                        : Math.round(
                            (userData.personalityTraits[0] * 100) / 35
                          ) <= 45
                        ? "Baixa"
                        : "Média"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Energia</th>
                  <td>
                    <p>{answer2 === "high" ? "Alta" : "Baixa"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[1] * 100) / 35) >=
                      55
                        ? "Alta"
                        : Math.round(
                            (userData.personalityTraits[1] * 100) / 35
                          ) <= 45
                        ? "Baixa"
                        : "Média"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Sociabilidade</th>
                  <td>
                    <p>{answer3 === "high" ? "Alta" : "Baixa"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[2] * 100) / 35) >=
                      55
                        ? "Alta"
                        : Math.round(
                            (userData.personalityTraits[2] * 100) / 35
                          ) <= 45
                        ? "Baixa"
                        : "Média"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Seguimento de Regras (Organização)</th>
                  <td>
                    <p>{answer4 === "high" ? "Alta" : "Baixa"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[3] * 100) / 40) >=
                      55
                        ? "Alta"
                        : Math.round(
                            (userData.personalityTraits[3] * 100) / 40
                          ) <= 45
                        ? "Baixa"
                        : "Média"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Imaginação (Abstração)</th>
                  <td>
                    <p>{answer5 === "high" ? "Alta" : "Baixa"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[4] * 100) / 50) >=
                      55
                        ? "Alta"
                        : Math.round(
                            (userData.personalityTraits[4] * 100) / 50
                          ) <= 45
                        ? "Baixa"
                        : "Média"}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>Assertividade (Manejo das Emoções)</th>
                  <td>
                    <p>{answer6 === "high" ? "Alta" : "Baixa"}</p>
                  </td>
                  <td>
                    <p>
                      {Math.round((userData.personalityTraits[5] * 100) / 50) >=
                      55
                        ? "Alta"
                        : Math.round(
                            (userData.personalityTraits[5] * 100) / 50
                          ) <= 45
                        ? "Baixa"
                        : "Média"}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}
        {step === 6 && (
          <div className={css.gridMainContainer}>
            <h1>💡Lembre:</h1>
            <p>
              "Você é mais do que seus impulsos. Você também é aquilo que
              escolhe sustentar."
            </p>
          </div>
        )}
        {step === 7 && (
          <div className={css.gridMainContainer}>
            <h1>
              🌱 Parabéns. Compreender suas bases é uma forma poderosa de
              autocuidado.
            </h1>
            <p>
              Na próxima etapa, vamos explorar como seus valores ajudam a guiar
              suas escolhas — mesmo em dias difíceis.
            </p>
          </div>
        )}
      </section>
      <div>
        {/* <hr /> */}

        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === 4 ? (
            answer1 && answer2 && answer3 && answer4 && answer5 && answer6 ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => {
                  setStep(step + 1);
                }}
              >
                Próximo
              </button>
            ) : (
              <button className={`greenButton ${css.buttonDisabled}`}>
                Próximo
              </button>
            )
          ) : step === stepLength ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Finalizar
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
